import React from 'react';
import './style.css';

// Helper function to map card string to image path
const getCardImage = (cardCode) => {
  if (!cardCode) return null;
  try {
    if (cardCode.length < 3) {
      return null;
    }
    const cleanCode = cardCode.replace(/\.(jpg|png)$/i, '');
    return `/assets/img/cards/${cleanCode}.png`;
  } catch (e) {
    return null;
  }
};

// Helper function to parse card string and split into Player and Banker cards
const parseCards = (cardString) => {
  if (!cardString) return { player: [], banker: [] };
  
  const cards = cardString.split(',');
  const playerCards = cards.slice(0, 3).map(card => getCardImage(card.trim()));
  const bankerCards = cards.slice(3, 6).map(card => getCardImage(card.trim()));
  
  return { player: playerCards, banker: bankerCards };
};

// Helper function to parse rdesc: "Player#-#No#No#Big"
const parseRdesc = (rdesc) => {
  if (!rdesc) return {};
  
  const parts = rdesc.split('#');
  return {
    winner: parts[0] || "",
    winnerPair: parts[1] || "-",
    perfect: parts[2] || "No",
    either: parts[3] || "No",
    bigSmall: parts[4] || ""
  };
};

const Baccarat = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  const cards = detailResult?.card ? parseCards(detailResult.card) : { player: [], banker: [] };
  const rdescData = detailResult?.rdesc ? parseRdesc(detailResult.rdesc) : {};
  const winner = detailResult?.winnat || "";
  const isPlayerWinner = detailResult?.win === "1" || winner === "Player";
  const isBankerWinner = detailResult?.win === "2" || winner === "Banker";

  return (
    <div>
      {/* Heading */}
      <div className="text-center">
        <h6>Baccarat Result</h6>
      </div>

      {/* Round ID and Player Cards Section */}
      <div className="d-block text-center">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <span className="float-right round-id">
                <b>Round ID:</b> {roundId}
              </span>
            </div>
          </div>
          <div className="row bottom-border-casino m-t-10">
            <div className="col-md-12">
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '12px' }} className="player-image-container">
                <div className="text-center player-number" style={{ flex: '1' }}>
                  <h4>Player</h4>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '8px' }}>
                    {cards.player?.map((card, index) => (
                      card && (
                        <img
                          key={index}
                          src={card}
                          alt={`Player Card ${index + 1}`}
                          onError={(e) => {
                            const cardName = card.split('/').pop();
                            const fallbackPath = `/assets/img/card-results/${cardName}`;
                            if (e.target.src !== fallbackPath) {
                              e.target.src = fallbackPath;
                            } else {
                              e.target.style.display = 'none';
                            }
                          }}
                        />
                      )
                    ))}
                  </div>
                  <div className="text-center">
                    {isPlayerWinner ? (
                      <label style={{ width: '100%' }} className="winner-label bg-success m-t-20">
                        <i className="fas fa-trophy m-r-5"></i>Winner
                      </label>
                    ) : (
                      <label className="m-t-20">&nbsp;</label>
                    )}
                  </div>
                </div>

                <div className="text-center player-number" style={{ flex: '1' }}>
                  <h4>Banker</h4>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '8px' }}>
                    {cards.banker?.map((card, index) => (
                      card && (
                        <img
                          key={index}
                          src={card}
                          alt={`Banker Card ${index + 1}`}
                          onError={(e) => {
                            const cardName = card.split('/').pop();
                            const fallbackPath = `/assets/img/card-results/${cardName}`;
                            if (e.target.src !== fallbackPath) {
                              e.target.src = fallbackPath;
                            } else {
                              e.target.style.display = 'none';
                            }
                          }}
                        />
                      )
                    ))}
                  </div>
                  <div className="text-center">
                    {isBankerWinner ? (
                      <label style={{ width: '100%' }} className="winner-label bg-success m-t-20">
                        <i className="fas fa-trophy m-r-5"></i>Winner
                      </label>
                    ) : (
                      <label className="m-t-20">&nbsp;</label>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Result Details */}
      {/* {rdescData && (rdescData.winner || rdescData.winnerPair || rdescData.bigSmall) && (
        <div className="mt-4 text-left">
          {rdescData.winner && (
            <p className="m-b-0">
              <b>Winner:</b> {rdescData.winner}
            </p>
          )}
          {rdescData.winnerPair && (
            <p className="m-b-0">
              <b>Winner Pair:</b> {rdescData.winnerPair}
            </p>
          )}
          {rdescData.bigSmall && (
            <p className="m-b-0">
              <b>Big/Small:</b> {rdescData.bigSmall}
            </p>
          )}
        </div>
      )} */}
    </div>
  );
};

export default Baccarat;

